"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "status-title title" }, "Jelenlegi státusza", -1);
const _hoisted_2 = {
    key: 0,
    class: "status value active"
};
const _hoisted_3 = {
    key: 1,
    class: "status value inactive"
};
exports.default = (0, vue_1.defineComponent)({
    __name: 'CardStatus',
    props: {
        active: {
            type: Boolean,
            default: false,
        },
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                _hoisted_1,
                (__props.active)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_2, "Elérhető"))
                    : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_3, "Nem elérhető"))
            ], 64));
        };
    }
});
